import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (pw.length < 6) return toast.error("పాస్‌వర్డ్ కనీసం 6 అక్షరాలు ఉండాలి");
    if (pw !== pw2) return toast.error("రెండు పాస్‌వర్డ్‌లు ఒకేలా లేవు");
    setBusy(true);
    try { await api.post("/auth/reset-password", { token, password: pw }); toast.success("పాస్‌వర్డ్ మార్చబడింది ✅ ఇప్పుడు లాగిన్ అవ్వండి"); nav("/auth?mode=login"); }
    catch (e) { const d = e?.response?.data?.detail; toast.error(typeof d === "string" ? d : "లోపం జరిగింది"); } finally { setBusy(false); }
  };

  return (
    <div className="parchment-texture min-h-screen flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-surface rounded-2xl temple-shadow gold-border p-6 sm:p-8 font-telugu space-y-3" data-testid="reset-page">
        <h1 className="font-display text-2xl font-extrabold text-maroon text-center">కొత్త పాస్‌వర్డ్ పెట్టండి</h1>
        {!token ? <p className="text-sm text-red-700 text-center" data-testid="reset-no-token">లింక్ సరిగా లేదు. మళ్ళీ రీసెట్ లింక్ అడగండి.</p> : (<>
          <div><Label className="text-maroon">కొత్త పాస్‌వర్డ్</Label>
            <Input data-testid="reset-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="gold-border" /></div>
          <div><Label className="text-maroon">మళ్ళీ టైప్ చేయండి</Label>
            <Input data-testid="reset-password-confirm" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} className="gold-border" /></div>
          <Button data-testid="reset-submit" onClick={submit} disabled={busy} className="w-full btn-sacred border-0">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "పాస్‌వర్డ్ మార్చండి"}</Button>
        </>)}
        <p className="text-center text-sm"><Link to="/forgot-password" className="text-saffron underline mr-4" data-testid="reset-new-link">కొత్త లింక్ అడగండి</Link><Link to="/auth?mode=login" className="text-saffron underline" data-testid="reset-back-login">లాగిన్</Link></p>
      </div>
    </div>
  );
}
